import { type CSSProperties } from 'react';
import { TSparseOrganization } from '@modules/users';
import { type TLibraryIconVariant } from '@shared/icons';
import { TERMINOLOGY } from '@shared/i18n';
import { TDocument } from '../types';

export type TInsertBlockConfig = {
  key: 'product' | 'global';
  blocksRoot?: string;
  iconVariant: TLibraryIconVariant;
  label: { lower: string; upper: string };
  show: boolean;
  style?: CSSProperties;
};

const isOnProductTree = (doc: Pick<TDocument, 'path'>, organization: Pick<TSparseOrganization, 'folders'>): boolean => {
  const rootFolderId = doc.path[0];
  return (
    Boolean(rootFolderId) && rootFolderId !== organization.folders.qm && rootFolderId !== organization.folders.countries
  );
};

const getInsertBlocks = (doc: TDocument, organization: Pick<TSparseOrganization, 'folders'>): TInsertBlockConfig[] => [
  {
    key: 'product',
    blocksRoot: doc.insertBlocks.productBlocksRoot,
    iconVariant: 'default',
    label: TERMINOLOGY.productDatabase,
    show: isOnProductTree(doc, organization),
    style: { paddingLeft: '6px' },
  },
  {
    key: 'global',
    blocksRoot: doc.insertBlocks.globalBlocksRoot,
    iconVariant: 'qm',
    label: TERMINOLOGY.qmDatabase,
    show: Boolean(organization.folders.qmBlocks),
  },
];

export default getInsertBlocks;
